import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  const d = aboutData;

  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 mb-4">
            <i className="ri-information-line text-secondary-600 text-sm"></i>
            <span className="text-secondary-700 text-xs font-medium">关于我们</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            {d.title}
          </h2>
          <p className="text-xl md:text-2xl text-primary-500 font-heading font-bold mb-6">
            {d.subtitle}
          </p>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-10">
            {d.description}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {d.stats.map((stat, idx) => (
              <div
                key={stat.label}
                className="relative p-6 rounded-xl bg-background-50 border border-background-200/70"
              >
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center">
                  <span className="text-background-50 text-xs font-bold">{idx + 1}</span>
                </div>
                <div className="font-heading text-3xl md:text-4xl font-black text-accent-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}